$('.table--scrollable').wrap('<div class="scrollable"></div>');



// WEBPACK FOOTER //
// ./project/client/src/site__pch/components/wysiwyg/tables.js